<div class="mt-4">
  <tail-email-builder></tail-email-builder>
</div>